import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useEffect, useState } from 'react';
import Icon, { MenuOutlined,  PlusCircleFilled , MinusCircleFilled, CloseSquareOutlined, EditOutlined, ArrowLeftOutlined} from '@ant-design/icons';
import { Button, Drawer, Form, Input, Menu, Popconfirm, Switch } from 'antd';
import { menu } from './Dash';
import { addSupplierFunction, checkLogIn, getEnterpriseInfo, getSuppliers, messageGeneral, removeSupplier } from './Functions';
import { useForm } from 'antd/es/form/Form';



function Suppliers() {
  const navigate = useNavigate();
  const [addSuppliers, setAddSuppliers]           = useState(false);
  const [openMessage, setOpenMessage]             = useState(false);
  const [message, setMessage]                     = useState('');
  const [openDrawer, setOpenDrawer]               = useState(false)
  const [ suppliers, setSuppliers]                = useState([])
  const [ form] = useForm()
  const [context, start ]                         = messageGeneral();

    const [edit, setEdit] = useState(null)
      useEffect(()=>{
        if( edit == null) return;
        form.setFieldValue('businessName',  edit.businessName);
        form.setFieldValue('vat', edit.vatNumber);
        //form.setFieldValue('store', edit.pointOfSale.token);
    },[edit])

  async function callSuppliers() {
    setSuppliers( await getSuppliers() );
  }

  useEffect(() => {
    if(checkLogIn() == null ) navigate('/');
    if( getEnterpriseInfo().role == 'operator') navigate('/movements')
  },[])

  useEffect(()=>{
    callSuppliers()
  }, [])

  const Conferma = ( child, token ) => {
    
    async function remove() {
     const r = await removeSupplier(token);
     if( r ){
      start('Fornitore eliminato')
      callSuppliers()
     }
    }
  
    return (
      <Popconfirm
        title="Sei sicuro di voler eliminare?"
        onConfirm={()=> remove()}
        okText="Sì"
        cancelText="No"
      >
        { child }
      </Popconfirm>
    );
  };

  async function register(value) {
    try{
      const {businessName, vat} = value;
      const add = await addSupplierFunction(businessName, vat, vat,edit ? edit.token : null);
      if( add ){
        if(edit){
          await callSuppliers()
          setAddSuppliers(false)
          form.resetFields()
          start('Fornitore modificato')
          return;
        }
        form.resetFields()
        start('Fornitore aggiunto')
      }
    }catch(err){
      console.log(err)
    }
  } 


  return (
    <div className="center bg-color-primary all-viewport">
      {context}
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      <div onClick={()=> setOpenDrawer(true)} style={{position:'fixed', top: '10px', left:'10px'}}>
        <MenuOutlined style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
      </div>
      <div style={{position:'fixed', top: '10px', right:'10px'}}>
        {
          addSuppliers 
          ?
          < ArrowLeftOutlined onClick={() => {setAddSuppliers(false); callSuppliers(); setEdit(null); form.resetFields() }} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
          :
          < PlusCircleFilled onClick={()  =>{ setAddSuppliers(true); callSuppliers()}} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
        }
      </div>
      <div className='table-smart' style={{position:'fixed', left:0, top:0,  height:'100%', width:'10%', backgroundColor:'white', zIndex: 20}}>
        {
           menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
                className='center'
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'15px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )}
      </div>
   <Drawer
        className='bg-color-secondary'
        placement='left'
        open={openDrawer}
        onClose={()=> setOpenDrawer(false)}
      >
        <div style={{height:'100%', width: '100%', overflowY: 'auto'}}>
          {
            menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'20px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )
          }
        </div>
      </Drawer> 
       {
       addSuppliers
       ?   
        <Form
        form={form}
            onFinish={register}
          >
            <div className='center text-style' style={{ marginBottom:'10px'}}> { edit ? 'Modifica fornitore' : 'Aggiungi fornitore'} </div>
            <Form.Item
                name="businessName"
                rules={[{ required: true, message: 'Inserire ragione sociale' }]}
              >
                <Input className='input-style' placeholder='Ragione sociale'/>
            </Form.Item>
            <Form.Item
                name="vat"
                rules={[{ required: true, message: 'Inserire p.iva o codice fiscale' }]}
              >
                <Input className='input-style' placeholder='PIVA/Codice fiscale'/>
            </Form.Item>
           
            <Button
              className='input-style color-one'
              type="primary" 
              htmlType="submit">
              { edit ? 'Modifica' :'Aggiungi' }</Button>
          </Form>
          :
          <div  style={{ height:'100%', width:'100%', backgroundColor:''}} className='center'> 
            <div className='center' style={{ height:'70%', width:'80%', backgroundColor:'', flexDirection:'column'}}>
              <div className='center text-style' style={{ marginBottom:'10px'}}> Lista fornitori </div>
              <div style={{width:'100%', maxWidth:'500px', height: '100%', overflowY:'auto', backgroundColor:'', marginTop:'20px'}}>
                {
                  suppliers.map((s, index) => {
                    return (
                    <div className='center' style={{ padding:'10px', textAlign:'center', backgroundColor: (index %2 == 0) ? 'rgba(52, 121, 57, 0.5)' : 'rgba(52, 121, 57, 0.2)'   }}>
                          <div className='center' style={{ width:'100%', height:'40px', justifyContent:'flex-start'}} key={index}> { s.businessName } </div>
                          { Conferma(<CloseSquareOutlined  style={{color:'red', fontSize:'25px'}} />, s.token) }
                          <div style={{width:'20px'}}/>
                              { <EditOutlined onClick={()=>{
                                setEdit(s)
                                setAddSuppliers(true);
                              }}  style={{color:'rgba(52, 121, 57, 1)', fontSize:'25px', }} /> }
                    </div>
                        )
                  })
                }
              </div>
            </div>
          </div>
        }

    </div>
  );
}

export default Suppliers;
